const formatPrice = (price) => {
    if (price !== null && price !== undefined)
        return new Intl.NumberFormat("it-IT", {
            minimumFractionDigits: 2,
        }).format(price?.toFixed(2));
};

export { formatPrice };
